import { types } from 'mobx-state-tree';
import { OrderTotalType } from '../types/OrderTotalClass';

const OrderTotalValue = types.model('OrderTotalValue', {
  analytics_value: types.number,
  class: OrderTotalType,
  name: types.string,
  text: types.optional(types.string, ''),
  value: types.number
});

export default OrderTotalValue;



// WEBPACK FOOTER //
// ./src/models/OrderTotalValue.js